import { SVGProps } from 'react';

const PostProjectCollaboration = ({ props }: { props?: SVGProps<SVGSVGElement> }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="534" height="340" viewBox="0 0 534 340" fill="none" {...props}>
    <g clipPath="url(#pac-clip)">
      <g filter="url(#pac-blur)">
        <ellipse
          cx="328.854"
          cy="237.945"
          fill="#430B07"
          rx="328.854"
          ry="237.945"
          transform="scale(-1 1) rotate(-1.064 9872.706 34178.611)"
        />
      </g>
      <path
        fill="url(#pac-c)"
        d="M260.044 170.052a7.33 7.33 0 0 1 6.956 7.319v.916a7.33 7.33 0 0 1 6.956-7.319l.377-.01a7.33 7.33 0 0 1-7.333-7.329v-.916a7.331 7.331 0 0 1-7.333 7.329l.377.01Z"
      />
      <path
        fill="url(#pac-d)"
        fillRule="evenodd"
        d="M336.667 94a7.331 7.331 0 0 1 7.333 7.329v62.3a7.33 7.33 0 0 1-7.333 7.329h-62.334a7.33 7.33 0 0 1-7.333-7.329v-62.3A7.331 7.331 0 0 1 274.333 94h62.334ZM267 178.287v-.916a7.33 7.33 0 0 0-6.956-7.319l-.377-.01h-62.334a7.33 7.33 0 0 0-7.333 7.329v62.3a7.33 7.33 0 0 0 7.333 7.329h62.334a7.33 7.33 0 0 0 7.333-7.329v-61.384Z"
        clipRule="evenodd"
      />
      <rect width="32" height="32" x="291" y="194" fill="#FA541C" rx="8" />
      <rect width="32" height="32" x="211" y="115" fill="#FA541C" rx="8" />
    </g>
    <defs>
      <linearGradient id="pac-c" x1="280.309" x2="190.031" y1="151.494" y2="247.029" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FA541C" />
        <stop offset="1" stopColor="#430B07" />
      </linearGradient>
      <linearGradient id="pac-d" x1="280.309" x2="190.031" y1="151.494" y2="247.029" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FA541C" />
        <stop offset="1" stopColor="#430B07" />
      </linearGradient>
      <clipPath id="pac-clip">
        <rect width="534" height="340" fill="#fff" rx="12.622" />
      </clipPath>
      <filter
        id="pac-blur"
        width="1257.66"
        height="1075.97"
        x="-329.103"
        y="-116.973"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_186_1758" stdDeviation="150" />
      </filter>
    </defs>
  </svg>
);

export default PostProjectCollaboration;
